import React, { useState, useEffect } from "react";
import Man from '../assets/images/man.jpg';
import { auth } from '../firebase';

function UserProfile() {
    const [username] = useState("");
    const [user, setUser] = useState(null);
  
    useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((authUser) => {
          if (authUser) {
              console.log(authUser);
              setUser(authUser);
  
          } else {
              setUser(null);
          }
  
          return () => {
            unsubscribe();
          }
          
          
      })
    }, [user, username]);


        return ( 
            <div className="container d-flex flex-column align-items-center mt-3">

                <div className="card d-flex flex-column align-items-center">
                <img src={Man} alt="userImage" width="200" className="rounded" />

                <div className="mt-3 card-body">
                    <p>@ <strong>{user?.displayName}</strong></p>
                </div>
                </div>

            </div>
         );
    }

 
export default UserProfile;